import * as Sentry from "@sentry/react";

const DSN = "https://5954be85ab715d4352ea0f73e4596eed@o4511637271871488.ingest.us.sentry.io/4511667342999552";

let initialized = false;

export function initSentry() {
  if (initialized) return;
  if (typeof window === "undefined") return;
  initialized = true;

  Sentry.init({
    dsn: DSN,
    // Injected at build time by vite.config.ts — identical to the release used
    // for the source-map upload, so stack traces resolve correctly.
    release: import.meta.env.VITE_SENTRY_RELEASE,
    integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
    tracesSampleRate: 0.2,
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,
    environment: import.meta.env.MODE,
  });

  // Bridge Lovable's error reporting hook into Sentry so React error boundary
  // errors flow through to sentry.io as well.
  const events = (window.__lovableEvents ??= {});
  const existing = events.captureException;
  events.captureException = (error, context, options) => {
    try {
      Sentry.captureException(error, {
        extra: context,
        tags: { mechanism: options?.mechanism, handled: options?.handled },
        level: options?.severity,
      });
    } catch {
      // ignore
    }
    existing?.(error, context, options);
  };
}

export { Sentry };
